<script>
import { cloneDeep } from 'lodash-es';
import { mapActions, mapState } from 'vuex';

export default {
  name: 'SkiPassPickupPlaces',
  props: {
    rental: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      localPickupPlaces: [],
      headers: [
        {
          text: 'Title',
          align: 'left',
          sortable: false,
          value: 'title',
        },
        {
          text: 'Description',
          align: 'left',
          headersLength: 2,
          sortable: false,
          value: 'description',
        },
        {
          text: 'Selected',
          align: 'left',
          sortable: false,
          value: 'selected',
        },
      ],
    };
  },
  created() {
    if (!this.rental) {
      this.getSeasonSkiPickupPlaces();
    } else {
      this.getSeasonSkiRentalPickupPlaces();
    }
  },
  watch: {
    skiPassPickupPlaces(value) {
      if (value.length) {
        this.localPickupPlaces = cloneDeep(value);
      }
    },
    skiRentalPickupPlaces(value) {
      if (value.length) {
        this.localPickupPlaces = cloneDeep(value);
      }
    },
  },
  computed: {
    ...mapState({
      skiPassPickupPlaces: state => state.skipass.pickupPlaces.items,
      skiRentalPickupPlaces: state => state.skirental.pickupPlaces.items,
      skiPassPickupPlacesLoading: state => state.skipass.pickupPlaces.loading,
      loading: state => state.skirental.pickupPlaces.loading,
    }),
  },
  methods: {
    ...mapActions({
      getSeasonSkiPickupPlaces: 'skipass/getSeasonPickupPlaces',
      updateSeasonSkiPickupPlaces: 'skipass/updateSeasonPickupPlaces',
      getSeasonSkiRentalPickupPlaces: 'skirental/getSeasonSkiRentalPickupPlaces',
      updateSeasonRentalPickupPlaces: 'skirental/updateSeasonRentalPickupPlaces',
    }),
    updatePickupPlaces() {
      const selected = this.localPickupPlaces.filter(e => e.selected);
      const ids = selected.map(select => select.id);
      if (!this.rental) {
        this.updateSeasonSkiPickupPlaces(ids);
      } else {
        this.updateSeasonRentalPickupPlaces(ids);
      }
    },
  },
};
</script>

<template>
  <v-container>
    <v-data-table
      v-if="localPickupPlaces"
      :headers="headers"
      :items="localPickupPlaces"
      :loading="skiPassPickupPlacesLoading || loading"
      class="elevation-1"
      hide-actions
    >
    <template v-slot:items="props">
      <td>{{ props.item.title }}</td>
      <td>{{ props.item.description }}</td>
      <td class="selector">
        <v-checkbox
          v-model="props.item.selected"
          label="Select"
          class="mt-4"
        />
      </td>
    </template>
    </v-data-table>
    <v-btn
      color="success"
      class="mt-5"
      @click="updatePickupPlaces"
    >
      Save
    </v-btn>
  </v-container>
</template>

<style lang="scss" scoped>
  .selector {
    width: 100px !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/ski/skipass/SkiPassPickupPlaces.vue